const ExclamationCircle = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fillRule="evenodd">
      <path d="M11.98 22.73c-5.937 0-10.75-4.813-10.75-10.75S6.043 1.23 11.98 1.23s10.75 4.813 10.75 10.75-4.813 10.75-10.75 10.75zm0-.862c5.461 0 9.888-4.427 9.888-9.888 0-5.462-4.427-9.889-9.888-9.889-5.462 0-9.889 4.427-9.889 9.889 0 5.461 4.427 9.888 9.889 9.888zM11 15h2v2h-2v-2zm0-8h2v6h-2V7z" />
    </g>
  </svg>
);

export default ExclamationCircle;
